import { action } from '@ember/object';
import { isBlank } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type VisitorGuideSectionModel from 'garaje/models/visitor-guide-section';

interface VisitorEmailsVisitorGuideManageTranslationsModalSectionRowSignature {
  Args: {
    isRTLLocale: boolean;
    section: VisitorGuideSectionModel;
    selectedLocale: {
      value: string;
    };
  };
}

export default class VisitorEmailsVisitorGuideManageTranslationsModalSectionRowComponent extends Component<VisitorEmailsVisitorGuideManageTranslationsModalSectionRowSignature> {
  @tracked titleLocaleValue;
  @tracked bodyLocaleValue;

  constructor(owner: unknown, args: VisitorEmailsVisitorGuideManageTranslationsModalSectionRowSignature['Args']) {
    super(owner, args);
    this.titleLocaleValue = this.lookupValue('title');
    this.bodyLocaleValue = this.lookupValue('body');
  }

  lookupValue(key: 'title' | 'body'): string {
    if (!this.args.selectedLocale) {
      return '';
    }
    const { value } = this.args.selectedLocale;
    const { customTranslations } = this.args.section;
    if (
      isBlank(customTranslations) ||
      isBlank(customTranslations[key]) ||
      typeof customTranslations[key][value] !== 'string'
    ) {
      return '';
    } else {
      return customTranslations[key][value];
    }
  }

  @action
  updateLocaleValues(): void {
    this.titleLocaleValue = this.lookupValue('title');
    this.bodyLocaleValue = this.lookupValue('body');
  }

  @action
  changeBodyValue({ target: { value } }: InputEvent & { target: HTMLTextAreaElement }): void {
    let { customTranslations } = this.args.section;
    if (isBlank(customTranslations)) {
      customTranslations = { body: {}, title: {} };
    }
    const body = customTranslations['body'];
    body[this.args.selectedLocale.value] = value.trim();
    this.args.section.customTranslations = { ...customTranslations, body };
  }
}
